module.exports = __webpack_public_path__ + "static/media/arrow.1745be55.svg";